module.exports = __webpack_public_path__ + "img/solution-ethernet-components.631c9963.png";